import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CalendarTodaySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CalendarTodaySVG;
